import React from 'react';

import { InfoOutlined as InfoOutlinedIcon } from '@mui/icons-material';
import { Box, Button } from '@mui/material';

import { Tooltip } from 'src/components/common';
import { useScreenInfo } from 'src/hooks/common';

import { viewReportButtonStyles } from '../shared/styles';

type InboxItemContentSubmitReverificationButtonProps = {
  openSubmitReverificationModal: () => void;
  isApproved: boolean;
  employerIsLive: boolean;
  isGovernmentVerifier: boolean;
};
export const InboxItemContentSubmitReverificationButton: React.FC<
  InboxItemContentSubmitReverificationButtonProps
> = ({ openSubmitReverificationModal, isApproved, employerIsLive, isGovernmentVerifier }) => {
  const { isMobile } = useScreenInfo();

  const disable = !isApproved || !employerIsLive;

  const tooltipTitle = React.useMemo(() => {
    if (!isApproved)
      return 'Permissible purpose used for Verification report is not approved by Clear Verify admin. Please contact support for assistance.';

    if (!employerIsLive)
      return 'One or some of the employers included in this verification request are no longer active on the platform';

    return '';
  }, [employerIsLive, isApproved]);

  const tooltipPlacement = isMobile ? 'bottom' : 'left';

  const renderButtonText = () => {
    if (isGovernmentVerifier) {
      return isMobile ? 'Request again' : 'Submit a request again ';
    }
    return isMobile ? 'Reverification' : 'Submit Reverification';
  };

  return (
    <Tooltip title={tooltipTitle} placement={tooltipPlacement} arrow enterTouchDelay={0}>
      <Box>
        <Button
          variant="contained"
          sx={viewReportButtonStyles}
          onClick={openSubmitReverificationModal}
          disabled={disable}
          endIcon={disable ? <InfoOutlinedIcon sx={{ height: '20px' }} /> : null}
        >
          {renderButtonText()}
        </Button>
      </Box>
    </Tooltip>
  );
};
